import { Component } from '@angular/core';
import { GeneralServiceService } from 'src/app/general-service.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent {

  constructor(private generalService : GeneralServiceService){

  }

  category = "Puebla";
  chooseCategory(e: any) {
    /*let radio = e.target;
    if (radio.checked) {
      this.category = radio.value;
      sessionStorage.setItem("category",this.category)
    }*/
    this.category = 'Puebla';
  }

  fetchedCategory : any
  fetchCategory(category : any){
    this.fetchedCategory = category
    this.generalService.setCategory(this.fetchedCategory)
    sessionStorage.setItem("fetchedCategory", this.fetchedCategory)
  }

}
